"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniCashierChannel = void 0;
const topic_1 = require("../../topic");
const MINI_CASHIER_CHANNEL = 'miniCashier';
class MiniCashierChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = MINI_CASHIER_CHANNEL;
        this.topics = {
            DetailsRetrieved: new topic_1.Topic('DetailsRetrieved', MINI_CASHIER_CHANNEL, this._logger),
            SetHeight: new topic_1.Topic('SetHeight', MINI_CASHIER_CHANNEL, this._logger),
            SetDirty: new topic_1.Topic('SetDirty', MINI_CASHIER_CHANNEL, this._logger),
        };
    }
}
exports.MiniCashierChannel = MiniCashierChannel;
//# sourceMappingURL=mini-cashier.channel.js.map